import { render, staticRenderFns } from "./DataPropertyDefinitionList.vue?vue&type=template&id=66b46ea2&scoped=true&"
import script from "./DataPropertyDefinitionList.vue?vue&type=script&lang=js&"
export * from "./DataPropertyDefinitionList.vue?vue&type=script&lang=js&"
import style0 from "./DataPropertyDefinitionList.vue?vue&type=style&index=0&id=66b46ea2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b46ea2",
  null
  
)

export default component.exports